import type { Cache } from '@urql/exchange-graphcache';

import { ExamPassFinishUpdateCacheFragmentDoc } from './graphql/ExamPassFinishUpdateCacheFragment.generated';

import type { DeepPartial } from '~/lib/types/DeepPartial';
import type { Mutation, MutationFinishExamPassArgs } from '~/types/graphql';

/**
 * urql Mutation Update Cache resolver for finishExamPass
 */
export function finishExamPassUpdate(
    result: DeepPartial<Pick<Mutation, 'finishExamPass'>>,
    args: MutationFinishExamPassArgs,
    cache: Cache,
) {
    if (!result?.finishExamPass) {
        return;
    }

    // endTime is an ISO string at this point as it hasn't run
    // through urqls serialization yet that makes it a date.
    const endTime = result?.finishExamPass?.examPass?.endTime as string;

    if (!endTime) {
        cache.invalidate({
            __typename: 'ExamPass',
            id: args.input.id,
        });

        return;
    }

    cache.writeFragment(ExamPassFinishUpdateCacheFragmentDoc, {
        __typename: 'ExamPass',
        id: args.input.id,

        // Per types expects a date, but setting a string here is the working approach.
        // @ts-ignore
        endTime: endTime,
    });
}
